import { useCallback, useRef, useState } from "react";

const useWebSocket = (url, onMessage) => {
  const webSocket = useRef(null);
  const [status, setStatus] = useState(0);

  const connect = useCallback(() => {
    console.log("Connecting to ivas server...", url);
    if (webSocket.current) {
      //return;
    }
    if (url && onMessage) {
      webSocket.current = new WebSocket(url);
    }

    webSocket.current.onopen = (event) => {
      setStatus(1);
    };

    webSocket.current.onmessage = (event) => {
      if (typeof onMessage === "function") {
        onMessage(event.data);
      }
    };

    webSocket.current.onclose = (event) => {
      setStatus(0);
    };

    return () => {
      if (webSocket.current?.readyState === WebSocket.OPEN) {
        webSocket.current.close();
      }
    };
  }, [url, onMessage]);

  const sendMessage = (message) => {
    if (webSocket.current.readyState === WebSocket.OPEN) {
      console.log("sending", message);
      webSocket.current.send(message);
    }
  };

  const close = () => {
    if (webSocket.current?.readyState === WebSocket.OPEN) {
      console.log("closing WebSocket...");
      webSocket.current.close();
    }
  };

  return { sendMessage, close, status, connect };
};

export default useWebSocket;
